import { useState, useEffect } from 'react';
import './Hero.css';

const images = [
  {
    url: "https://images.unsplash.com/photo-1666018215790-867b14fe4822?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMHBlb3BsZSUyMHNpZ25pbmclMjBwcm9wZXJ0eSUyMGNvbnRyYWN0fGVufDF8fHx8MTc3MTMwNTc3OXww&ixlib=rb-4.1.0&q=80&w=1080",
    alt: "Business people signing property contract"
  },
  {
    url: "https://images.unsplash.com/photo-1760561148422-bbb515696fb7?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjByZXNpZGVudGlhbCUyMHByb3BlcnR5JTIwYnVpbGRpbmd8ZW58MXx8fHwxNzcxMzA1Nzc5fDA&ixlib=rb-4.1.0&q=80&w=1080",
    alt: "Modern residential property"
  },
  {
    url: "https://images.unsplash.com/photo-1656646425130-6c6408d9ac89?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxjb21tZXJjaWFsJTIwb2ZmaWNlJTIwYnVpbGRpbmclMjBleHRlcmlvcnxlbnwxfHx8fDE3NzExODc5Mzd8MA&ixlib=rb-4.1.0&q=80&w=1080",
    alt: "Commercial office building"
  },
  {
    url: "https://images.unsplash.com/photo-1681505526188-b05e68c77582?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxyZWFsJTIwZXN0YXRlJTIwYWdlbnQlMjBoYW5kc2hha2UlMjBkZWFsfGVufDF8fHx8MTc3MTMwNTc4MHww&ixlib=rb-4.1.0&q=80&w=1080",
    alt: "Real estate handshake deal"
  },
  {
    url: "https://images.unsplash.com/photo-1763729805496-b5dbf7f00c79?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxsZWdhbCUyMGRvY3VtZW50cyUyMGNvbnRyYWN0JTIwcGFwZXJzfGVufDF8fHx8MTc3MTMwNTc4MHww&ixlib=rb-4.1.0&q=80&w=1080",
    alt: "Legal documents and contracts"
  }
];

export function Hero() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="hero-section">
      {/* Background image slideshow */}
      <div className="hero-bg">
        {images.map((image, index) => (
          <img
            key={index}
            src={image.url}
            alt={image.alt}
            className="hero-bg-image"
            style={{ opacity: index === currentImageIndex ? 1 : 0 }}
          />
        ))}
        <div className="hero-overlay" />
      </div>

      {/* Content */}
      <div className="hero-content">
        <div className="hero-grid">
          {/* Left content */}
          <div>
            <h1 className="hero-title">The Agreement Universe</h1>
            <p className="hero-subtitle">
              Find and create all types of property and legal agreements. Error free.
            </p>
            <p className="hero-desc">
              Create, save, download, and print agreements in minutes.
            </p>
          </div>

          {/* Right - Price badge */}
          <div className="hero-badge-wrapper">
            <div className="hero-badge">
              <div className="hero-badge-content">
                {/* <div className="hero-badge-tag">
                  <span>Limited Offer</span>
                </div> */}
                <h3 className="hero-badge-title">Create in Minutes</h3>
                <div>
                  <div className="hero-price-row">
                    <span className="hero-price-old">₹500</span>
                    <span className="hero-price-off">98% OFF</span>
                  </div>
                  <div className="hero-price-new">₹10</div>
                </div>
                <div className="hero-badge-line" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
